import React from 'react';

const SalleStats = ({ 
  activeSalles, 
  archivedSalles, 
  filteredSalles, 
  debouncedSearchTerm 
}) => {
  if (filteredSalles.length === 0) return null;

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm">
      <div className="flex flex-wrap gap-4">
        <div className="flex items-center">
          <div className="h-3 w-3 rounded-full bg-green-500 mr-2"></div>
          <span className="text-sm font-medium text-gray-700">
            {activeSalles.length} Salles actives
          </span>
        </div>
        <div className="flex items-center">
          <div className="h-3 w-3 rounded-full bg-gray-400 mr-2"></div>
          <span className="text-sm font-medium text-gray-700">
            {archivedSalles.length} Salles archivées
          </span>
        </div>
        {debouncedSearchTerm && (
          <div className="flex items-center ml-auto">
            <span className="text-sm text-gray-600">
              {filteredSalles.length} résultat(s) pour "{debouncedSearchTerm}"
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default SalleStats; 